import { render, staticRenderFns } from "./ModalReturnApproval.vue?vue&type=template&id=653449d4&"
import script from "./ModalReturnApproval.vue?vue&type=script&lang=js&"
export * from "./ModalReturnApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('653449d4')) {
      api.createRecord('653449d4', component.options)
    } else {
      api.reload('653449d4', component.options)
    }
    module.hot.accept("./ModalReturnApproval.vue?vue&type=template&id=653449d4&", function () {
      api.rerender('653449d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ModalReturnApproval.vue"
export default component.exports